export enum UserManagementTenantsOrderByColumnEnum {
  FNAME = "FNAME",
}

export enum UserManagementTenantsSortOrderEnum {
  ASC = "ASC",
  DESC = "DESC",
}
